"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFunctionCallComponents = exports.expertiseComponents = exports.default = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.find-index");

var _Base = _interopRequireDefault(require("./base/Base"));

var _Button = _interopRequireDefault(require("./button/Button"));

var _CategoryFile = _interopRequireDefault(require("./categoryfile/CategoryFile"));

var _Checkbox = _interopRequireDefault(require("./checkbox/Checkbox"));

var _Column = _interopRequireDefault(require("./columns/Column"));

var _Columns = _interopRequireDefault(require("./columns/Columns"));

var _Container = _interopRequireDefault(require("./container/Container"));

var _Currency = _interopRequireDefault(require("./currency/Currency"));

var _DataGrid = _interopRequireDefault(require("./datagrid/DataGrid"));

var _DataMap = _interopRequireDefault(require("./datamap/DataMap"));

var _DateTime = _interopRequireDefault(require("./datetime/DateTime"));

var _Day = _interopRequireDefault(require("./day/Day"));

var _EditGrid = _interopRequireDefault(require("./editgrid/EditGrid"));

var _Email = _interopRequireDefault(require("./email/Email"));

var _File = _interopRequireDefault(require("./file/File"));

var _StyledFile = _interopRequireDefault(require("./file/StyledFile"));

var _Form = _interopRequireDefault(require("./form/Form"));

var _HTML = _interopRequireDefault(require("./html/HTML"));

var _Hidden = _interopRequireDefault(require("./hidden/Hidden"));

var _MultilevelCatalog = _interopRequireDefault(require("./multilevel-catalog/MultilevelCatalog"));

var _NestedComponent = _interopRequireDefault(require("./nested/NestedComponent"));

var _Number = _interopRequireDefault(require("./number/Number"));

var _Panel = _interopRequireDefault(require("./panel/Panel"));

var _Password = _interopRequireDefault(require("./password/Password"));

var _PhoneNumber = _interopRequireDefault(require("./phonenumber/PhoneNumber"));

var _Radio = _interopRequireDefault(require("./radio/Radio"));

var _Select = _interopRequireDefault(require("./select/Select"));

var _SelectBoxes = _interopRequireDefault(require("./selectboxes/SelectBoxes"));

var _Table = _interopRequireDefault(require("./table/Table"));

var _Tabs = _interopRequireDefault(require("./tabs/Tabs"));

var _Tags = _interopRequireDefault(require("./tags/Tags"));

var _TextArea = _interopRequireDefault(require("./textarea/TextArea"));

var _Time = _interopRequireDefault(require("./time/Time"));

var _Tree = _interopRequireDefault(require("./tree/Tree"));

var _Unknown = _interopRequireDefault(require("./unknown/Unknown"));

var _Url = _interopRequireDefault(require("./url/Url"));

var _BaseEdit = _interopRequireDefault(require("./base/editForm/Base.edit.display"));

var _BaseEdit2 = _interopRequireDefault(require("./base/editForm/Base.edit.api"));

var _BaseEdit3 = _interopRequireDefault(require("./base/editForm/Base.edit.validation"));

var _Form2 = _interopRequireDefault(require("./expertise/Form"));

var _Criterion = _interopRequireDefault(require("./expertise/Criterion"));

var _Radio2 = _interopRequireDefault(require("./expertise/Radio"));

var _SelectBoxes2 = _interopRequireDefault(require("./expertise/SelectBoxes"));

var _SurveyRadio = _interopRequireDefault(require("./expertise/SurveyRadio"));

var _SurveyCheck = _interopRequireDefault(require("./expertise/SurveyCheck"));

var _ScoreInput = _interopRequireDefault(require("./expertise/ScoreInput"));

var _ScoreSelect = _interopRequireDefault(require("./expertise/ScoreSelect"));

var _CustomSelectComponent = _interopRequireDefault(require("./select/CustomSelectComponent"));

var _CustomTextFieldComponent = _interopRequireDefault(require("./textfield/CustomTextFieldComponent"));

var _Fieldset = _interopRequireDefault(require("./fieldset/Fieldset"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// изменяет поле description c textField на textarea (во всех формах)
_BaseEdit.default.map(function (field) {
  if (field.key === 'description') {
    field.type = 'textarea';
  }
});

var labelIndex = _BaseEdit.default.findIndex(function (field) {
  if (field.key === 'label') {
    return true;
  }
});

_BaseEdit.default.splice.apply(_BaseEdit.default, [labelIndex + 1, 0].concat(_toConsumableArray(_BaseEdit2.default.filter(function (field) {
  return field.key === 'key';
})), _toConsumableArray(_BaseEdit3.default.filter(function (field) {
  return field.key === 'validate.required';
}))));

_BaseEdit2.default.splice(_BaseEdit2.default.findIndex(function (field) {
  if (field.key === 'key') {
    return true;
  }
}), 1);

_BaseEdit3.default.splice(_BaseEdit3.default.findIndex(function (field) {
  if (field.key === 'validate.required') {
    return true;
  }
}), 1);

var _default = {
  base: _Base.default,
  button: _Button.default,
  checkbox: _Checkbox.default,
  column: _Column.default,
  columns: _Columns.default,
  container: _Container.default,
  currency: _Currency.default,
  datagrid: _DataGrid.default,
  datamap: _DataMap.default,
  datetime: _DateTime.default,
  day: _Day.default,
  editgrid: _EditGrid.default,
  email: _Email.default,
  file: _File.default,
  form: _Form.default,
  hidden: _Hidden.default,
  htmlelement: _HTML.default,
  nested: _NestedComponent.default,
  number: _Number.default,
  panel: _Panel.default,
  password: _Password.default,
  phoneNumber: _PhoneNumber.default,
  radio: _Radio.default,
  select: _Select.default,
  selectboxes: _SelectBoxes.default,
  table: _Table.default,
  tabs: _Tabs.default,
  tags: _Tags.default,
  textarea: _TextArea.default,
  textfield: _CustomTextFieldComponent.default,
  time: _Time.default,
  tree: _Tree.default,
  unknown: _Unknown.default,
  url: _Url.default,
  fieldset: _Fieldset.default
};
exports.default = _default;
var expertiseComponents = {
  expertiseForm: _Form2.default,
  expertiseCriterion: _Criterion.default,
  expertiseRadio: _Radio2.default,
  expertiseSelectBoxes: _SelectBoxes2.default,
  expertiseSurveyRadio: _SurveyRadio.default,
  expertiseSurveyCheck: _SurveyCheck.default,
  expertiseScoreInput: _ScoreInput.default
};
exports.expertiseComponents = expertiseComponents;
var withFunctionCallComponents = {
  categoryFile: _CategoryFile.default,
  styledFile: _StyledFile.default,
  select: _CustomSelectComponent.default,
  expertiseScoreSelect: _ScoreSelect.default,
  multilevelCatalog: _MultilevelCatalog.default
};
exports.withFunctionCallComponents = withFunctionCallComponents;